import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import CheckcircleIcon from 'icons/Checkcircle.icon';
import FileSecurityFeatureList from '../FileSecurityFeatureList';
import { FileSecurityLevelListItem } from '../FileSecurityFeatureList/FileSecurityFeatureList.component';

import './FileSecurityLevelCard.styles.scss';

type FileSecurityLevelCardProps = {
  className?: string;
  title: string;
  description: string;
  list: FileSecurityLevelListItem[];
  isSelected: boolean;
  isNotifyAction?: boolean;
  disabled?: boolean;
  onSelect: () => void;
};

const FileSecurityLevelCard: React.FC<FileSecurityLevelCardProps> = (props) => {
  const {
    className,
    title,
    description,
    list,
    isSelected,
    isNotifyAction = false,
    disabled = false,
    children,
    onSelect,
  } = props;

  const classes = classNames(
    'file-security-level-card',
    'white-panel',
    { selected: isSelected, disabled },
    className,
  );

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p className="title">{t(title)}</p>
      <p className="description">{t(description)}</p>

      <Button
        onClick={onSelect}
        iconPosition="right"
        icon={isSelected ? CheckcircleIcon : null}
        disabled={disabled}
      >
        {t(isNotifyAction ? 'notifyMe' : isSelected ? 'selected' : 'select')}
      </Button>

      <div
        className={classNames('file-security-level-card__content', {
          disabled: !isSelected,
        })}
      >
        <FileSecurityFeatureList list={list} />

        {children}
      </div>
    </div>
  );
};

export default FileSecurityLevelCard;
